module.exports = __webpack_public_path__ + "img/apple.eeb9c695.jpg";